module.exports = __webpack_public_path__ + "img/colorBox7.8e357241.jpg";